import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Aside, Overlay } from './Sidebar.style';
const Sidebar = (props) => {
    const { className, children, isOpen, onClose } = props;
    return (_jsxs(Fragment, { children: [_jsx(Overlay, { type: "button", isOpen: isOpen, onClick: onClose }), _jsx(Aside, { className: className, isOpen: isOpen, children: children })] }));
};
export default Sidebar;
